var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.25H26.25L23.625 16.625H7.875M23.625 20.125H8.75L4.375 1.75H1.75",
    stroke: "#09AA6E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 25.375C22.8415 25.375 23.625 24.5915 23.625 23.625C23.625 22.6585 22.8415 21.875 21.875 21.875C20.9085 21.875 20.125 22.6585 20.125 23.625C20.125 24.5915 20.9085 25.375 21.875 25.375Z",
    stroke: "#09AA6E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.375C11.4665 25.375 12.25 24.5915 12.25 23.625C12.25 22.6585 11.4665 21.875 10.5 21.875C9.5335 21.875 8.75 22.6585 8.75 23.625C8.75 24.5915 9.5335 25.375 10.5 25.375Z",
    stroke: "#09AA6E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.39165d89e9b4acb0265a0d47117107f4.svg";
export { ForwardRef as ReactComponent };